<template>
  
        <div class="col-30">
            <aside class="blog__sidebar">
 
 
                <div class="sidebar__widget">
                    <h4 class="sidebar__widget-title">Postingan Terbaru</h4>
 
                    <div class="sidebar__post-list" v-for="(item, index) in listBerita" :key="index">
                        <div class="sidebar__post-item" :key="index">
                            <div class="sidebar__post-thumb">
                                <a href="blog-details.html"><img :src="$store.state.UPLOADS+item.foto" alt="Apexa" /></a>
                            </div>
                            <div class="sidebar__post-content">
                                <h5 class="title" style="font-size: 14px;"><a href="blog-details.html">{{item.judul}}</a></h5>
                                <span class="date"><i class="flaticon-time"></i>{{UMUM.tglConvert(item.createAt).tgl}}</span>
                            </div>
                        </div>
 
                    </div>
                </div>

 

            </aside>
        </div>
 
</template>

<script>
import UMUM from "../library/umum";
export default {

    data() {
        return {
            UMUM:UMUM,
            listBerita:[],
        }
    },    
    methods: {

        fetchBerita() { 
            fetch(this.$store.state.BASE_URL + 'api/v1/web_publish_berita/homeOPD/', {
                method: "GET",
                headers: {
                "content-type": "application/json", 
                }, 
            })
            .then(res => res.json())
            .then(res_data => { 
                this.listBerita = res_data;
            });     
        },

    },
    mounted() {
        this.fetchBerita()
        
    },

}
</script>